<template>
  <div class="loanDetail">
    <!-- 贷款产品基本信息 -->
    <div class="basicInformation">
      <!-- 图片 -->
      <div class="Image">
        <!-- <img :src="propsList.logoUrl" alt="Loan Logo" /> -->
        <van-image :src="obj.logoUrl" alt="图片已损坏" fit="fill" />
      </div>
      <!-- 基本信息 -->
      <div class="content">
        <!-- 标题 -->
        <div class="loansTitle">
          <span class="title">{{ propsList.title }}</span>
          <div class="approvalType">
            <!-- <van-icon size="15" name="fire" color="red" /> -->
            <span class="approvalText">极速审批</span>
          </div>
        </div>
        <!-- 所属银行 -->
        <!-- <div class="bank">中国工商银行</div> -->
        <div class="Money">
          <span class="loansMoney">{{ propsList.priceSection }}</span>
          <!-- <span class="txt">万元</span> -->
        </div>
        <div class="tit">可贷款金额</div>
      </div>
    </div>

    <!-- 标题 -->
    <div class="Title">
      <div class="bigTitle">
        <div class="show">
          <div class="line"></div>
          <span>产品详情</span>
          <div class="line"></div>
        </div>
        <div class="letters">OVERVIEW</div>
      </div>
    </div>

    <!-- 贷款的详细信息 -->
    <div class="loanDetails">
      <div class="innerBox">
        <div class="msgBox">
          <div class="title">贷款额度</div>
          <div class="tit">{{ propsList.newMoney }}</div>
        </div>
        <div class="msgBox">
          <div class="title">利率</div>
          <div class="tit">年利率{{ propsList.changeRate }}</div>
        </div>
        <div class="msgBox">
          <div class="title">贷款期限</div>
          <div class="tit">
            {{ propsList.changeTime }}
          </div>
        </div>
        <div class="msgBox">
          <div class="title">贷款方式</div>
          <div class="tit">{{ propsList.creditType }}</div>
        </div>
        <div class="msgBox">
          <div class="title">还款方式</div>
          <div class="tit">{{ propsList.repayType }}</div>
        </div>
      </div>
    </div>

    <!-- 产品介绍 -->
    <div class="productIntroduction">
      <div class="innerBox">
        <span class="title">产品介绍</span>
        <div class="content">
          {{ propsList.introduction }}
        </div>
      </div>
    </div>

    <!-- 服务对象 -->
    <div class="serviceObject">
      <div class="innerBox">
        <span class="title">服务对象</span>
        <div class="content">
          {{ propsList.serviceUser }}
        </div>
      </div>
    </div>
    <div></div>

    <!-- 立即申请 -->
    <div class="btn">
      <div class="innerBox">
        <button @click="apply(propsList)">立即申请</button>
      </div>
    </div>

    <!-- 空标签 -->
    <div class="empty"></div>
  </div>
</template>

<!-- <script
  type="text/javascript"
  src="https://res.wx.qq.com/open/js/jweixin-1.3.2.js"
></script> -->
<script>
import Vue from "vue";
import {
  DetailsFinancialProducts,
  ScreeningCondition,
} from "@/api/RuralFinance";
import { Dialog, Toast, Image as VanImage } from "vant";
import wx from "weixin-js-sdk";
Vue.use(Dialog, Toast, VanImage);
export default {
  name: "wxf",
  data() {
    return {
      financeProductId: "",
      param2: "",
      obj: {},
      propsList: [],
      identityObj: {},
      userId: "",
      accessToken: "",
    };
  },
  mounted() {
    //隐藏头部和底部
    // const header = document.querySelector('.header');
    // const noShow = document.querySelector('.noShow')
    const homeManage = document.querySelector(".home-manage");
    // const footer = document.querySelector('.footer-web');

    // if (header) header.style.display = "none";
    // if (footer) footer.style.display = "none";
    // if (noShow) noShow.style.display = "none";
    if (homeManage) homeManage.style.paddingTop = "0";

    this.initParams();

    if (typeof wx !== "undefined" && wx.miniProgram) {
      this.initWx();
    }
  },
  methods: {
    initParams() {
      try {
        const queryParams = this.$route.query;

        this.financeProductId = JSON.parse(queryParams.financeProductId);
        this.identityObj = queryParams.identityObj;
        this.userId = queryParams.userId;
        this.accessToken = queryParams.access_token;

        console.log("to load");
        this.onLoad({ financeProductId: this.financeProductId });
      } catch (error) {
        console.log(error, "error");
      }
    },
    initWx() {
      // wx.config({
      //   debug: true,
      //   appId: "wx1b4a19d2537a3306",
      //   timestamp: Math.floor(Date.now() / 1000),
      //   nonceStr: Math.random().toString(36).substr(2, 15),
      //   signature: '0f9de62fce790f9a083d5c99e95740ceb90c27ed', // 确保 signature 正确
      //   jsApiList: ["scanQRCode", "chooseImage", "navigateTo"],
      // });
      // wx.ready(() => {
      //   console.log("WeChat SDK is ready.");
      //   Dialog.alert({
      //     title: 'ready',
      //     message: 'WeChat SDK is ready.'
      //   });
      // });
    },
    handleNavigation() {
      if (typeof wx !== "undefined" && wx.miniProgram) {
        wx.miniProgram.navigateTo({
          url: "/pages/Publish/Publish",
        });
      } else {
        console.warn("Not in WeChat Mini Program environment.");
      }
    },
    async onLoad(options) {
      // 贷款详情
      let params = {
        financeProductId: options.financeProductId,
      };
      console.log(options, "options");

      let resData = await DetailsFinancialProducts(params);
      console.log(resData, "resData");
      if (resData.data[0]) {
        this.obj = resData.data[0];
        this.obj.logoUrl =
          "/api/admin/file/get?ossFilePath=" + this.obj.logoUrl;
      } else {
        this.$router.push({ name: "xctfw", query: { queryParams: "" } });
      }

      let propsList1 = resData.data[0];
      propsList1.introduction = propsList1.introduction
        ? propsList1.introduction
        : "暂无数据";
      propsList1.serviceUser = propsList1.serviceUser
        ? propsList1.serviceUser
        : "暂无数据";

      // 还款方式
      let params1 = "repay_type";
      let res = await ScreeningCondition(params1);
      console.log(res, "还款方式");
      let TorRepayType = res.data;
      let arr2 = Array.from(propsList1.repayType.split(","));
      let repay_Type = "";
      for (let i = 0; i < TorRepayType.length; i++) {
        if (arr2.indexOf(TorRepayType[i].value) > -1) {
          repay_Type += TorRepayType[i].description + " ";
        }
      }
      propsList1.repayType = repay_Type;

      //贷款方式
      let params2 = "credit_type";
      let loanData = await ScreeningCondition(params2);
      console.log(loanData, "贷款方式");
      let ToGuaranteeMethods = loanData.data;
      let arr = Array.from(propsList1.creditType.split(","));
      let credit_type_name = "";
      for (let i = 0; i < ToGuaranteeMethods.length; i++) {
        if (arr.indexOf(ToGuaranteeMethods[i].value) > -1) {
          credit_type_name += ToGuaranteeMethods[i].description + " ";
        }
      }
      propsList1.creditType = credit_type_name;

      // 处理贷款金额显示
      let newMoney = "";
      if (
        propsList1.minMoney != 0 &&
        propsList1.maxMoney != 0 &&
        propsList1.minMoney != propsList1.maxMoney
      ) {
        if (propsList1.minMoney < 10000 && propsList1.maxMoney < 10000) {
          newMoney =
            propsList1.minMoney + "元" + "~" + propsList1.maxMoney + "元";
        } else if (
          propsList1.minMoney < 10000 &&
          propsList1.maxMoney >= 10000
        ) {
          newMoney =
            propsList1.minMoney +
            "元" +
            "~" +
            propsList1.maxMoney / 10000 +
            "万元";
        } else {
          newMoney =
            propsList1.minMoney / 10000 +
            "万元" +
            "~" +
            propsList1.maxMoney / 10000 +
            "万元";
        }
      } else if (
        propsList1.minMoney != 0 &&
        propsList1.maxMoney != 0 &&
        propsList1.minMoney == propsList1.maxMoney
      ) {
        if (propsList1.minMoney < 10000) {
          newMoney = propsList1.minMoney + "元";
        } else {
          newMoney = propsList1.minMoney / 10000 + "万元";
        }
      } else if (propsList1.minMoney != 0 && propsList1.maxMoney == 0) {
        if (propsList1.minMoney < 10000) {
          newMoney = propsList1.minMoney + "元起";
        } else {
          newMoney = propsList1.minMoney / 10000 + "万元起";
        }
      } else if (propsList1.minMoney == 0 && propsList1.maxMoney != 0) {
        if (propsList1.maxMoney < 10000) {
          newMoney = "最高" + propsList1.maxMoney + "元";
        } else {
          newMoney = "最高" + propsList1.maxMoney / 10000 + "万元";
        }
      }
      propsList1.newMoney = newMoney;
      propsList1.priceSection = newMoney;

      // 处理贷款期限显示
      let changeTime = "";
      if (
        propsList1.minTime != 0 &&
        propsList1.maxTime != 0 &&
        propsList1.minTime != propsList1.maxTime
      ) {
        changeTime =
          propsList1.minTime + "个月" + "~" + propsList1.maxTime + "个月";
      } else if (
        propsList1.minTime != 0 &&
        propsList1.maxTime != 0 &&
        propsList1.minTime == propsList1.maxTime
      ) {
        changeTime = propsList1.minTime + "个月";
      } else if (propsList1.minTime != 0 && propsList1.maxTime == 0) {
        changeTime = propsList1.minTime + "个月起";
      } else if (propsList1.minTime == 0 && propsList1.maxTime != 0) {
        changeTime = "最高" + propsList1.maxTime + "个月";
      }
      propsList1.changeTime = changeTime;

      //处理贷款额度
      let changeRate = "";
      if (
        propsList1.minRate != 0 &&
        propsList1.maxRate != 0 &&
        propsList1.minRate != propsList1.maxRate
      ) {
        changeRate = propsList1.minRate + "%" + "~" + propsList1.maxRate + "%";
      } else if (
        propsList1.minRate != 0 &&
        propsList1.maxRate != 0 &&
        propsList1.minRate == propsList1.maxRate
      ) {
        changeRate = propsList1.minRate + "%";
      } else if (propsList1.minRate != 0 && propsList1.maxRate == 0) {
        changeRate = propsList1.minRate + "%起";
      } else if (propsList1.minRate == 0 && propsList1.maxRate != 0) {
        changeRate = "最高" + propsList1.maxRate + "%";
      }
      propsList1.changeRate = changeRate;
      //改变图片样式
      // propsList1.logoUrl = `${app.globalData.imgurl}/admin/file/get?ossFilePath=${propsList1.logoUrl}`;

      this.propsList = propsList1;
    },
    apply() {
      if (JSON.parse(this.identityObj).identityTypeCode) {
        this.$router.push({
          name: "dksq",
          query: {
            queryParams: {
              identityObj: this.identityObj,
              financeProductId: this.financeProductId,
              userId: this.userId,
              accessToken: this.accessToken,
              title: this.propsList.title,
              loanTypeId: this.obj.loanTypeId,
            },
          },
        });
      } else {
        Toast("您还未登录，即将跳转登录页");
        setTimeout(() => {
          this.wx.miniProgram.navigateTo({ url: "/pagesB/login/login" });
        }, 1000);
      }
    },
  },
};
</script>
<style lang="less" scoped>
html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  font-family: "Source Han Sans CN", sans-serif;
}

div {
  box-sizing: border-box;
}

/* 贷款详细信息 */
.loanDetail {
  text-align: center;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 60vh;
  padding: 20px;

  .basicInformation {
    width: 100%;
    display: flex;
    background: white;
    padding: 20px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

    .Image {
      margin-right: 20px;

      img {
        width: 110px;
        height: 110px;
        border-radius: 10px;
      }

      .img {
        border: solid 1px black;
        border-radius: 15px;
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      word-wrap: break-word;

      .loansTitle {
        display: flex;
        align-items: center;

        .title {
          font-weight: 400;
          font-size: 22px;
          color: #000000;
        }

        .approvalType {
          margin-left: 20px;
          padding: 10px 20px;
          background-color: #f3eadb;
          border-radius: 12px;
          font-weight: 400;
          font-size: 16px;
          color: #a08926;
        }
      }

      .Money {
        margin-top: 20px;
        font-weight: bold;
        font-size: 33px;
        color: #d25731;
      }

      .bank {
        margin-top: 30px;
        font-size: 16px;
        color: #666666;
      }

      .tit {
        margin: 13px 0;
        font-weight: 400;
        font-size: 16px;
        color: #666666;
      }

      .txt {
        color: #d25731;
        font-size: 12px;
        font-weight: bold;
      }
    }
  }
}

/* 标题 */
.Title {
  width: 100%;
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f9f9f9;

  .bigTitle {
    display: flex;
    flex-direction: column;
    align-items: center;

    .show {
      font-size: 36px;
      font-weight: bold;
      display: flex;
      align-items: center;

      .line {
        margin: 0 10px;
        width: 50px;
        border-bottom: solid 2px #aaaaaa;
      }
    }

    .letters {
      font-size: 22px;
      color: #acacac;
    }
  }
}

/* 贷款详细信息 */
.loanDetails {
  width: 100%;
  background: white;
  display: flex;
  justify-content: center;
  padding: 40px 0;

  .innerBox {
    width: 90%;
    max-width: 1200px;

    .msgBox {
      width: 100%;
      display: flex;
      padding-bottom: 39px;
      justify-content: space-between;

      .title {
        color: #999999;
        display: flex;
        align-items: center;
        font-size: 18px;
      }

      .tit {
        width: 75%;
        font-size: 16px;
        text-align: right;
      }
    }
  }
}

/* 产品介绍 */
.productIntroduction {
  width: 100%;
  margin-top: 20px;
  background: white;
  display: flex;
  justify-content: center;
  padding: 40px 0;

  .innerBox {
    width: 100%;
    max-width: 1200px;

    .title {
      font-size: 22px;
      font-weight: bold;
      color: #a08926;
    }

    .content {
      padding-top: 29px;
      font-size: 14px;
      color: #333;
    }
  }
}

/* 服务对象 */
.serviceObject {
  width: 100%;
  padding-top: 52px;
  background: white;
  display: flex;
  justify-content: center;
  padding-bottom: 22px;

  .innerBox {
    width: 90%;
    max-width: 1200px;

    .title {
      font-size: 22px;
      font-weight: bold;
      color: #a08926;
    }

    .content {
      padding-top: 29px;
      font-size: 14px;
      color: #333;
    }
  }
}

/* 立即申请 */
.btn {
  width: 100%;
  display: flex;
  justify-content: center;
  background: #ffffff;

  .innerBox {
    width: 670px;
    height: 79px;
    display: flex;
    justify-content: center;

    button {
      width: 100vw;
      max-width: 561px;
      background: black;
      color: white;
      border: none;
      border-radius: 40px;
      padding: 15px;
      font-size: 18px;
      cursor: pointer;
    }
  }
}

/* 空标签 */
.empty {
  width: 100%;
  height: 150px;
  background: #ffffff;
}

/* 响应式设计 */
@media (max-width: 760px) {
  .loanDetail {
    width: 100vw;

    height: auto;
    padding: 10px;
    font-size: 0.5rem;
  }

  .basicInformation {
    flex-direction: column;
    align-items: center;
    font-size: 0.5rem;
  }

  .Image {
    margin-right: 0;
    margin-bottom: 10px;
    font-size: 0.5rem;
  }

  .content {
    margin-left: 0;
    text-align: center;
    font-size: 0.5rem;
  }

  .btn .innerBox {
    width: 100vw;
    height: auto;
    font-size: 0.5rem;
  }

  .tit {
    font-size: 0.5rem;
  }

  button {
    font-size: 0.5rem;
    padding: 10px;
  }
}
</style>
